import { useClassNames } from "@/hooks/useClassNames"

type SpinnerProps = {
  size?: "sm" | "md" | "lg" | "xl"
  className?: string
}

export const Spinner = ({ size = "md", className }: SpinnerProps) => {
  const sizeClasses = {
    sm: "h-4 w-4 border-2",
    md: "h-6 w-6 border-2",
    lg: "h-8 w-8 border-4",
    xl: "h-12 w-12 border-4",
  }

  return (
    <div
      role="status"
      aria-label="Loading"
      className={useClassNames(
        "rounded-full border-brand-pink/20 border-t-brand-pink animate-spin",
        sizeClasses[size],
        className
      )}
    />
  )
}
